import config from '@linc-technologies/linced-common/utils/config';

export function initialize(applicationInstance) {
  if (config.environment === 'test') {
    return;
  }
  applicationInstance.lookup('service:faro');
}

export default {
  name: 'faro',
  initialize,
};
